import { ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";

export function ProDriverThreadsEmptyScreen() {
  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-2 text-gray-400">
      <ChatBubbleLeftRightIcon className="h-12 w-12" />
      <p className="text-sm">Select a thread</p>
    </div>
  );
}
